import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorTextMedium } = theme();

  return StyleSheet.create({
    description: {
      color: colorTextMedium,
    },
  });
};

export { style };
